import { render, staticRenderFns } from "./reviewer-certification-lists.component.vue?vue&type=template&id=3d124c70&"
import script from "./reviewer-certification-lists.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-certification-lists.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-certification-lists.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports